// hooks/useTableDataFetch.js
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAPI } from "../../../../API/ApiService";
import { sortTableData } from "../../../../utils/function";
import { setFetchPending } from "../../../../slices/invitationSlice";
import { showErrorToast } from "../../../../utils/Toast/toast";

export const useTableDataFetch = (config) => {
  const {
    url,
    dataTransformer = (data) => data,
    sortKey = "firstName",
    filterFn = (item) => true,
    initialFetch = true,
  } = config;

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const hasFetched = useRef(false);
  const { fetch } = useSelector((store) => store.invitation);
  const dispatch = useDispatch();

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await getAPI(url);
      let data = response?.data?.response ?? [];

      // Apply filter if provided
      data = data.filter(filterFn);

      // Transform data
      const transformedData = dataTransformer(data);

      // Sort data
      const sortedData = sortTableData(transformedData, sortKey);

      setRows(sortedData);
    } catch (e) {
      showErrorToast("Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  // Initial load
  useEffect(() => {
    if (initialFetch && !hasFetched.current) {
      hasFetched.current = true;
      fetchData();
    }
  }, [initialFetch]);

  // Reload when fetch flag changes
  useEffect(() => {
    if (fetch) {
      fetchData().finally(() => {
        dispatch(setFetchPending(false));
      });
    }
  }, [fetch, dispatch]);

  return { rows, loading, refetch: fetchData };
};
